import useProfileQuery from '../queries/use-profile-query'
import { STREAM_URL_TYPE, STREAM_HOST_BY_TYPE } from '../constant/stream'

const matchUrlRegex = /src=['"](.*?)['"]/
const matchUrlTypeRegex = /\/([^/]+)\.php/

const getUrlFromIframe = (iframe: string) => {
    const match = iframe.match(matchUrlRegex)
    return match ? match[1] : ''
}

const getStreamType = (url: string) => {
    const match = url.match(matchUrlTypeRegex)
    const hasMatch = match ? match[1] : null
    return hasMatch === STREAM_URL_TYPE.PREMIUM
        ? STREAM_URL_TYPE.PREMIUM
        : STREAM_URL_TYPE.FREE
}

export const useUserStreamUrl = (iframe: string, sportId?: string) => {
    const { isValidSubscription, token } = useProfileQuery()

    const getCorrespondingIframeUrl = (
        requiredType: STREAM_URL_TYPE,
        currentType: STREAM_URL_TYPE,
        url: string
    ) => {
        const objectURL = new URL(url)
        const searchParams = new URLSearchParams(objectURL.search)
        objectURL.host = STREAM_HOST_BY_TYPE[requiredType]
        if (requiredType === STREAM_URL_TYPE.PREMIUM) {
            searchParams.set('token', token || '')
        } else {
            searchParams.delete('token')
        }
        if (sportId) {
            searchParams.set('sport_uuid', sportId)
        }
        objectURL.search = searchParams.toString()
        return objectURL.toString().replace(currentType, requiredType)
    }

    const getUpdatedIframe = (currentIframe: string) => {
        const streamUrl = getUrlFromIframe(currentIframe)
        if (!streamUrl) return currentIframe
        const currentStreamType = getStreamType(streamUrl)
        const requiredStreamType = isValidSubscription
            ? STREAM_URL_TYPE.PREMIUM
            : STREAM_URL_TYPE.FREE
        const updatedUrl = getCorrespondingIframeUrl(
            requiredStreamType,
            currentStreamType,
            streamUrl
        )
        return currentIframe.replace(streamUrl, updatedUrl)
    }

    return getUpdatedIframe(iframe)
}
